webpackJsonp([13],{

/***/ "ULWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VNavInner_vue__ = __webpack_require__("sWW8");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67fcf310_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VNavInner_vue__ = __webpack_require__("sTg/");
function injectStyle (ssrContext) {
  __webpack_require__("wLgr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VNavInner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67fcf310_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VNavInner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lynt":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n#placeholder {\n  height: 1.066667rem;\n  width: 100%;\n}\n.nav-wrap {\n  background: #fff;\n  z-index: 100;\n  -webkit-box-shadow: 0 0.053333rem 0.106667rem 0 rgba(92, 99, 133, 0.06);\n          box-shadow: 0 0.053333rem 0.106667rem 0 rgba(92, 99, 133, 0.06);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 100%;\n  height: 1.066667rem;\n  padding: 0.266667rem 0 0.266667rem 0.48rem;\n  line-height: 1.066667rem;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  white-space: nowrap;\n}\n.nav-wrap a {\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n}\n.nav-wrap .nav-list {\n  width: 100%;\n}\n.nav-wrap .nav-list .nav-li {\n  display: inline-block;\n  height: 0.533333rem;\n  line-height: 0.533333rem;\n  font-size: 14px;\n}\n.nav-wrap .nav-list .nav-li .title {\n  color: #656565;\n  display: inline-block;\n  width: 100%;\n}\n.nav-wrap .nav-list .nav-li .nav-sign {\n  margin: 0 0.266667rem;\n  font-size: 0.4rem;\n  color: #d7d7d7;\n}\n.nav-wrap .nav-list .nav-li .active {\n  font-size: 16px;\n  color: #4c87d9;\n}\n.gradient-block {\n  height: 1.066667rem;\n  width: 1.44rem;\n  right: 0;\n  position: fixed;\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, 0)), color-stop(92%, #ffffff));\n  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 92%);\n}\n.nav-wrap.fixed-box {\n  position: fixed;\n  left: 0;\n  background: #fff;\n  z-index: 100;\n  -webkit-box-shadow: 0 0.053333rem 0.106667rem 0 rgba(92, 99, 133, 0.06);\n          box-shadow: 0 0.053333rem 0.106667rem 0 rgba(92, 99, 133, 0.06);\n}\n[data-dpr=\"1\"] .app-top-old {\n  top: 44px;\n}\n[data-dpr=\"2\"] .app-top-old {\n  top: 88px;\n}\n[data-dpr=\"3\"] .app-top-old {\n  top: 132px;\n}\n.app-top-new {\n  top: 0;\n}", ""]);

// exports


/***/ }),

/***/ "sTg/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.has_data)?_c('div',{staticClass:"nav-wrap fixed-box",class:_vm.fixed_top,attrs:{"id":_vm.target,"data-spm":"loc"}},[_c('ul',{staticClass:"nav-list clearfix"},[_vm._l((_vm.nav_list),function(nav,index){return [(nav.type === 15)?_c('li',{staticClass:"nav-li inner",attrs:{"data-inner-nav":"true"}},[(index !== 0)?_c('i',{staticClass:"nav-sign"},[_vm._v("/")]):_vm._e(),_c('a',{ref:"navTitle",refInFor:true,staticClass:"title",class:{active: _vm.isSelected ==nav.title},attrs:{"href":"javascript:;","data-target":nav.link,"data-title":nav.title},on:{"click":function($event){$event.preventDefault();_vm.jump2comp(nav.link, nav.title)}}},[_vm._v(_vm._s(nav.title))])]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"gradient-block",class:_vm.fixed_top})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sWW8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_util__ = __webpack_require__("XQ5N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__statistics_sohu_stat__ = __webpack_require__("K1MS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_eventHelper_js__ = __webpack_require__("YrTf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        target: {
            default: '',
            type: String
        },
        spm: {
            default: '',
            type: String
        },
        data: {
            default: [],
            type: Array
        },
        findex: {
            default: '',
            type: [String, Number]
        }
    },
    data: function data() {
        return {
            navHeight: 84,
            navScrollHeight: 88,
            posClass: 'fixed-box',
            isSelected: this.data[0].title,
            isFixed: false,
            isVisible: false,
            isClickedScroll: false,
            srollValue: 0,
            lastScrollValue: 0,
            timer: null
        };
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$nextTick(function () {
            var innerNavList = document.getElementById(_this2.target) && document.getElementById(_this2.target).querySelectorAll('div[data-inner-nav="true"]');
            _this2.$emit('inner_nav_mounted', innerNavList);
        });
        this.initScroll();
        //占位符
        var mainBlock = document.querySelector('.index-main');
        var newNode = document.createElement("div");
        newNode.setAttribute('id', 'placeholder');
        mainBlock.before(newNode);
    },

    methods: {
        //导航栏移动事件
        navScrollToView: function navScrollToView(_link) {
            var navDom = document.querySelector('.nav-wrap');
            var navWidth = navDom.getBoundingClientRect().width;
            var navLiDom = document.querySelector('a[data-target=' + _link + ']');
            var navPos = navLiDom && navLiDom.getBoundingClientRect();
            if (navPos && navPos.left + navPos.width > navWidth) {
                navDom.scrollLeft += 2 * navPos.width;
            } else if (navPos && navPos.left < navPos.width) {
                navDom.scrollLeft -= 2 * navPos.width;
            }
        },
        initScroll: function initScroll(e) {
            var _this3 = this;

            var dom = document.querySelector('.nav-wrap');
            var titleTop = dom.offsetTop;
            var moduleDom = document.getElementsByClassName('module-wrap');
            __WEBPACK_IMPORTED_MODULE_2__utils_eventHelper_js__["a" /* default */].addHandler(window, 'scroll', __WEBPACK_IMPORTED_MODULE_0__utils_util__["a" /* default */].throttle(function () {
                //滚动条距离
                var btop = document.body.scrollTop || document.documentElement.scrollTop;
                var nowNav = '';
                var minObj = {
                    index: undefined,
                    differ: undefined
                };
                var navId = null;

                //判断是否滚动结束
                clearTimeout(_this3.timer); // 每次滚动前 清除一次
                _this3.timer = setTimeout(function () {
                    _this3.lastScrollValue = btop;
                    if (_this3.lastScrollValue == _this3.srollValue) {
                        _this3.isClickedScroll = false;
                    }
                }, 500);
                _this3.srollValue = btop;
                //导航栏随滚动条颜色变化
                for (var i = 0; i < moduleDom.length; i++) {
                    var differ = Math.abs(moduleDom[i].offsetTop - (btop + _this3.navScrollHeight));

                    if (moduleDom[i]) {

                        if (minObj.differ == undefined) {
                            minObj.index = i;
                            minObj.differ = differ;
                        } else if (minObj.differ >= differ && moduleDom[i].offsetTop < btop + _this3.navScrollHeight) {
                            minObj.index = i;
                            minObj.differ = differ;
                        }
                    }
                }

                navId = moduleDom[minObj.index] && moduleDom[minObj.index].getAttribute('id');

                _this3.navScrollToView(navId);
                if (!_this3.isClickedScroll) {
                    _this3.$refs.navTitle.forEach(function (item, idx) {
                        if (item.dataset.target == navId) {
                            _this3.isSelected = item.dataset.title;
                        }
                    });
                }
            }, 300));
        },
        jump2comp: function jump2comp(_link, _title) {
            var _this = this;
            var scrollY = window.scrollY;
            var dom = document.getElementById(_link);
            var type = _link.split("_")[0];
            var tmpArr = void 0;
            var typeIndex = void 0;
            var targetPos = void 0;

            this.isClickedScroll = true;
            this.isSelected = _title;

            if (dom) {
                targetPos = dom.getBoundingClientRect();
                window.scrollTo(0, scrollY + targetPos.top - _this.navHeight);
                __WEBPACK_IMPORTED_MODULE_1__statistics_sohu_stat__["a" /* default */].sendActionStat('10120454');
            }
            this.navScrollToView(_link);

            //埋点相关
            var subData = typeof window !== 'undefined' ? window.subData : {};
            var dynamicComponents = subData.dynamicComponents;
            dynamicComponents.forEach(function (comp, index) {
                //遍历数据，当_link == comp.targetid时,comp就是要跳转的组件
                if (_link == comp.targetId) {
                    //comp.name是'栏目组件_1'这样的格式，通过分割字符串,取到后边的数字，用于导航点击事件的参数  
                    tmpArr = comp.name.split('_');
                    typeIndex = tmpArr[1];
                }
            });
            // 埋点-导航点击事件
            if (window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                window.sohuSpm.sendAction({
                    acode: 8006,
                    clkParam: 'to:' + type + '-' + typeIndex
                });
            }
        }
    },

    computed: {
        nav_list: function nav_list() {
            var subId = window.subData.id;
            var flagIndex = this.findex;
            var state_flag = void 0;
            this.data.forEach(function (item, index) {
                state_flag = 'm-' + subId + '_subnavi_' + flagIndex + '_' + (index + 1);
                item.state_flag = state_flag;
                if (item.type !== 15) {
                    item.link = __WEBPACK_IMPORTED_MODULE_0__utils_util__["a" /* default */].addQueryArgs(item.link, {
                        _f: state_flag
                    });
                }
            });
            return this.data;
        },
        has_data: function has_data() {
            return this.data.length > 0;
        },
        fixed_top: function fixed_top() {
            return window.subData.hasHeader ? 'app-top-old' : window.subData.hasHeaderBlank ? 'app-top-old' : 'app-top-new';
        }
    }
});

/***/ }),

/***/ "wLgr":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("lynt");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("eb4c4da6", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/13.a831ead1276efed3113a.js